import React from 'react';

import './box.scss';

interface BoxProps {
    padding?: 'none' | 'sm' | 'md' | 'lg';
    anchorIdName?: string;
    className?: string;
    children: React.ReactNode;
}

const Box: React.FC<BoxProps> = ({ padding = 'md', anchorIdName, children, className }: BoxProps) => {
    return (
        <div className={`box box--${padding} ${className || ''}`} id={anchorIdName}>
            {children}
        </div>
    );
};

export default Box;
